import axios from "axios";
import { authHeader } from "./utils";
import {
  GET_WORKER,
  LIST_WORKER,
  LIST_ATTENDANCE,
  LIST_WORKER_LANGUAGE,
} from "./types";

export const getWorker = (id) => async (dispatch) => {
  const res = await axios.get(`/api/workers/${id}`, {
    headers: authHeader(),
  });
  // console.log("res", res.data);
  dispatch({ type: GET_WORKER, payload: res.data });
};

export const fetchWorkers =
  ({ page, limit, all }) =>
  async (dispatch) => {
    const res = await axios.get("/api/workers", {
      headers: authHeader(),
      params: { page, limit, all },
    });
    console.log("res", res.data);
    dispatch({ type: LIST_WORKER, payload: res.data });
  };

export const submitWorker =
  ({ worker }, navigate) =>
  async (dispatch) => {
    const res = await axios.post("/api/workers", worker, {
      headers: authHeader(),
    });
    navigate("/workers");
    // dispatch({ type: GET_WORKER, payload: {} });
  };

export const updateWorker =
  ({ worker, id }, navigate) =>
  async (dispatch) => {
    // console.log("user", worker);
    // console.log("id", id);
    const res = await axios.put(`/api/workers/${id}`, worker, {
      headers: authHeader(),
    });
    navigate("/workers");
    // dispatch({ type: LIST_WORKER, payload: [] });
  };

export const deleteWorker =
  ({ id }, navigate) =>
  async (dispatch) => {
    try {
      const res = await axios.delete(`/api/workers/${id}`, {
        headers: authHeader(),
      });
      navigate("/workers");
    } catch (error) {
      console.log(error);
    }
  };

export const fetchWorkerLanguages = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/workers/languages", {
      headers: authHeader(),
    });
    // console.log("res", res);
    dispatch({ type: LIST_WORKER_LANGUAGE, payload: res.data });
  } catch (error) {
    console.log(error);
  }
};

export const fetchAttendances =
  ({ page, limit, all = false }) =>
  async (dispatch) => {
    try {
      const res = await axios.get("/api/workers/attendances", {
        headers: authHeader(),
        params: { page, limit, all },
      });
      console.log("res", res.data);
      dispatch({ type: LIST_ATTENDANCE, payload: res.data });
    } catch (error) {
      console.log(error);
    }
  };

export const attendanceOffice =
  ({ attendance, id }) =>
  async () => {
    try {
      const res = await axios.post(
        `/api/workers/${id}/attendances`,
        attendance,
        {
          headers: authHeader(),
        }
      );
      // console.log("res", res);
      // dispatch({ type: LIST_ATTENDANCE, payload: res.data });
    } catch (error) {
      console.log(error);
    }
  };
